const RankTypes = {
    FETCH_START:    '[HOSTESS][RANK] FETCH START',
    FETCH_SUCCESS:  '[HOSTESS][RANK] FETCH SUCCESS',
    FETCH_FAILURE:  '[HOSTESS][RANK] FETCH FAILURE'
};

export default RankTypes;